export const RING_TONE_SOUND_FILE = 'panther-ring.mp3';
export const BEEP_TONE_SOUND_FILE = 'panther-beep.mp3';